import { injectGlobal } from 'styled-components';

injectGlobal`

  @import url('https://fonts.googleapis.com/css?family=Open+Sans|Noto+Serif');

  html, body, div, span, object, iframe,
  h1, h2, h3, h4, h5, h6, p, blockquote, pre,
  abbr, address, cite, code,
  del, dfn, em, img, ins, kbd, q, samp,
  small, strong, sub, sup, var,
  b, i,
  dl, dt, dd, ol, ul, li,
  fieldset, form, label, legend,
  table, caption, tbody, tfoot, thead, tr, th, td,
  article, aside, canvas, details, figcaption, figure,
  footer, header, hgroup, menu, nav, section, summary,
  time, mark, audio, video {
      margin:0;
      padding:0;
      border:0;
      outline:0;
      vertical-align:baseline;
      background:transparent;
  }

  article,aside,details,figcaption,figure,
  footer,header,hgroup,menu,nav,section {
      display:block;
  }

  body {
    font-family: 'Noto Serif', serif;
    color: #6b7381;
    background: #f6f6f6;
  }

  a {
    color: #aaa;
    text-decoration: none;
  }

  a:hover,
  a:active {
    color: #333;
  }

  h1, h2 {
    text-shadow: 1px 1px 2px #e4e4e4;
    margin: 1em 0;
    color: #333333;
  }

  p {
    font-size: 1.13em;
    line-height: 160%;
  }

  input, textarea {
    min-width: 600px;
    padding: 15px;
    margin: 6px 0 20px;
    border: 1px solid #ccc;
    font-size: 14px;
    display: block;
  }

  textarea {
    min-height: 250px;
  }

  input[type=submit] {
    background-color: #70ab90;
    border: none;
    min-width: auto;
    color: #ffffff;
    font-size: 16px;
  }

  .sticky {
    z-index: 5;
  }

  .sticky header .site-logo {
    height: 75px;
    width: 75px;
  }

  .alert {
    position: relative;
    padding: .75rem 1.25rem;
    margin-bottom: 1rem;
    border: 1px solid transparent;
    border-radius: .25rem;
  }

  .alert-success {
    color: #155724;
    background-color: #d4edda;
    border-color: #c3e6cb;
  }

  .alert-danger {
    color: #721c24;
    background-color: #f8d7da;
    border-color: #f5c6cb;
  }

  .alert-warning {
    color: #856404;
    background-color: #fff3cd;
    border-color: #ffeeba;
  }

  .alert-info {
    color: #0c5460;
    background-color: #d1ecf1;
    border-color: #bee5eb;
  }

  @media (max-width: 992px) {

    h1 {
      font-size:1.5em;
    }

  }

  @media (max-width: 767px) {

    h1 {
      font-size: 1.2em;
    }

    input, textarea {
      width: 94%;
      min-width: auto;
      padding:15px 3%;
    }

  }

`;



// WEBPACK FOOTER //
// ./src/theme/GlobalStyle.js